define.alias("shared/utils/is-async-relation", "auth/utils/is-async-relation");